import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';

import {
  // Private module
  TEST_PAGE_PATH,
  ADMIN_IMPERSONATE_USER_PAGE_PATH,
  REDIRECT_PAGE_PATH,
  EXTERNAL_REDIRECT_PAGE_PATH,
  NOT_FOUND_PAGE_PATH,
  DEVICE_QR_PAGE_PATH,

  // Profile module
  WELCOME_PAGE_PATH,
  LOGIN_PAGE_PATH,
  LOGOUT_PAGE_PATH,
  RESET_PASSWORD_PAGE_PATH,
  SET_NEW_PASSWORD_PAGE_PATH,
  MY_PROFILE_PAGE_PATH,
  PASSWORD_CHANGE_REQUIRED_PAGE_PATH,
  MY_CERTIFICATES_PAGE_PATH,
  MY_COMPANY_SETTINGS_PAGE_PATH,
  EXPIRED_RESET_LINK_PAGE_PATH,
  NOTIFICATION_SETTINGS_PAGE_PATH,
  DEVICE_TYPES_PAGE_PATH,
  DEVICE_SUBTYPES_PAGE_PATH,
  ADD_DEVICE_SUBTYPE_PAGE_PATH,
  EDIT_DEVICE_SUBTYPE_PAGE_PATH,

  // Admin module
  USERS_PAGE_PATH,
  ADD_USER_PAGE_PATH,
  ORGANIZATIONS_PAGE_PATH,
  ADD_ORGANIZATION_PAGE_PATH,
  EDIT_ORGANIZATION_PAGE_PATH,
  ADD_DEPARTMENT_PAGE_PATH,
  EDIT_DEPARTMENT_PAGE_PATH,
  EDIT_USER_PAGE_PATH,
  DEPARTMENTS_PAGE_PATH,
  HIERARCHIES_PAGE_PATH,
  ADD_HIERARCHY_PAGE_PATH,
  EDIT_HIERARCHY_PAGE_PATH,
  REMOTE_SOURCES_PAGE_PATH,
  ADD_REMOTE_SOURCE_PAGE_PATH,
  EDIT_REMOTE_SOURCE_PAGE_PATH,
  COPY_REMOTE_SOURCE_PAGE_PATH,
  DASHBOARD_PAGE_PATH,
  EXPORT_PAGE_PATH,

  // Pre-defined data module
  USERS_PREDEFINED_DATA_PAGE_PATH,
  GLOBAL_PREDEFINED_DATA_PAGE_PATH,
  ADD_USERS_PREDEFINED_DATA_PAGE_PATH,
  ADD_GLOBAL_PREDEFINED_DATA_PAGE_PATH,
  EDIT_USERS_PREDEFINED_DATA_PAGE_PATH,
  EDIT_GLOBAL_PREDEFINED_DATA_PAGE_PATH,

  // Measuring devices module
  MEASURING_DEVICES_PAGE_PATH,
  ADD_MEASURING_DEVICE_PAGE_PATH,
  EDIT_MEASURING_DEVICE_PAGE_PATH,

  // Devices module
  DEVICES_PAGE_PATH,
  FAULTS_PAGE_PATH,
  ADD_DEVICE_PAGE_PATH,
  EDIT_DEVICE_PAGE_PATH,
  COPY_DEVICE_PAGE_PATH,
  DEVICE_FAULTS_PAGE_PATH,

  //Sync chastia
  CONFIG_REMOTE_SOURCE_PAGE_PATH,

  // Revisions module
  REVISIONS_PAGE_PATH,
  SIGNATURES_PAGE_PATH,
  SIGNATURE_PAGE_PATH,
  REVISION_PAGE_PATH,
  ADD_REVISION_PAGE_PATH,
  COPY_REVISION_PAGE_PATH,
  FILL_OUT_REVISION_PAGE_PATH,
  EDIT_REVISION_PAGE_PATH,
  REVISION_PLAN_ASSIGNMENTS_PAGE_PATH,
  SELECT_REVISION_TEMPLATE_AND_VISUAL_PAGE_PATH,
  DEVICE_REVISION_PLANS_PAGE_PATH,
  REVISION_TEMPLATES_PAGE_PATH,
  EDIT_REVISION_TEMPLATE_PAGE_PATH,
  COPY_REVISION_TEMPLATE_PAGE_PATH,
  ADD_REVISION_TEMPLATE_PAGE_PATH,
  TEMPLATE_EDITOR_PAGE_PATH,
  EVIDENCE_FIELDS_PAGE_PATH,
  EVIDENCE_FIELD_SECTIONS_PAGE_PATH,
  ADD_EVIDENCE_FIELD_SECTION_PAGE_PATH,
  EDIT_EVIDENCE_FIELD_SECTION_PAGE_PATH,
  ADD_EVIDENCE_FIELD_PAGE_PATH,
  EDIT_EVIDENCE_FIELD_PAGE_PATH,
  FORMS_PAGE_PATH,
  FORM_PAGE_PATH,
  ADD_FORM_PAGE_PATH,
  COPY_FORM_PAGE_PATH,
  EDIT_FORM_PAGE_PATH,
  SELECT_FORM_TEMPLATE_AND_VISUAL_PAGE_PATH,
  FILL_OUT_FORM_PAGE_PATH,
  PRICE_OFFERS_PAGE_PATH,
  ADD_PRICE_OFFER_PAGE_PATH,
  PRICE_OFFER_PAGE_PATH,
  PROVIDE_PRICE_OFFER_PAGE_PATH,
  HR_PEOPLE_PAGE_PATH,
  HR_CREATE_PERSON_PAGE_PATH,
  HR_COPY_PERSON_PAGE_PATH,
  HR_EDIT_PERSON_PAGE_PATH,
  HR_CREATE_PERSON_TERM_PAGE_PATH,
  HR_CREATE_PERSON_FILE_PAGE_PATH,
  HR_EDIT_PERSON_FILE_PAGE_PATH,
  HR_TERMS_PAGE_PATH,
  HR_BULK_CREATE_TERMS_PAGE_PATH,
  HR_TERM_PAGE_PATH,
  HR_TERM_TYPES_PAGE_PATH,
  HR_CREATE_TERM_TYPE_PAGE_PATH,
  HR_EDIT_TERM_TYPE_PAGE_PATH,
  HR_FILE_CATEGORIES_PAGE_PATH,
  HR_CREATE_FILE_CATEGORY_PAGE_PATH,
  HR_EDIT_FILE_CATEGORY_PAGE_PATH,
} from 'routes/paths';

// Private module
import TestPage from 'pages/private-module/test/TestPage';
import RedirectPage from 'pages/private-module/redirect/RedirectPage';
import ExternalRedirectPage from 'pages/private-module/external-redirect/ExternalRedirectPage';
import NotFoundPage from 'pages/private-module/not-found/NotFoundPage';
import DeviceQrRedirectPage from 'pages/devices-module/device/DeviceQrRedirectPage';

// Profile module
import WelcomePage from 'pages/profile-module/welcome/WelcomePage';

import LoginPage from 'pages/profile-module/session/LoginPage';
import LogoutPage from 'pages/profile-module/session/LogoutPage';

import ResetPasswordPage from 'pages/profile-module/password/ResetPasswordPage';
import SetNewPasswordPage from 'pages/profile-module/password/SetNewPasswordPage';
import ExpiredResetLinkPage from 'pages/profile-module/password/ExpiredResetLinkPage';
import PasswordChangeRequiredPage from 'pages/profile-module/password/PasswordChangeRequiredPage';

import MyProfilePage from 'pages/profile-module/personal/MyProfilePage';
import MyCertificatesPage from 'pages/profile-module/personal/MyCertificatesPage';
import MyCompanySettingsPage from 'pages/profile-module/personal/MyCompanySettingsPage';
import NotificationSettingsPage from 'pages/profile-module/personal/NotificationSettingsPage';

// Admin module
import DashboardPage from 'pages/admin-module/dashboard/DashboardPage';

import UsersPage from 'pages/admin-module/user/UsersPage';
import AddUserPage from 'pages/admin-module/user/AddUserPage';
import EditUserPage from 'pages/admin-module/user/EditUserPage';
import ImpersonateUserPage from 'pages/admin-module/user/ImpersonateUserPage';

import OrganizationsPage from 'pages/admin-module/organization/OrganizationsPage';
import AddOrganizationPage from 'pages/admin-module/organization/AddOrganizationPage';
import EditOrganizationPage from 'pages/admin-module/organization/EditOrganizationPage';

import DepartmentsPage from 'pages/admin-module/department/DepartmentsPage';
import AddDepartmentPage from 'pages/admin-module/department/AddDepartmentPage';
import EditDepartmentPage from 'pages/admin-module/department/EditDepartmentPage';
import HierarchiesPage from 'pages/admin-module/hierarchy/HierarchiesPage';
import AddHierarchyPage from 'pages/admin-module/hierarchy/AddHierarchyPage';
import EditHierarchyPage from 'pages/admin-module/hierarchy/EditHierarchyPage';

import RemoteSourcesPage from 'pages/admin-module/remote-source/RemoteSourcesPage';
import AddRemoteSourcePage from 'pages/admin-module/remote-source/AddRemoteSourcePage';
import EditRemoteSourcePage from 'pages/admin-module/remote-source/EditRemoteSourcePage';
import CopyRemoteSourcePage from 'pages/admin-module/remote-source/CopyRemoteSourcePage';
import ConfigRemoteSourcePage from 'pages/admin-module/remote-source/ConfigRemoteSourcePage';

// Pre-defined data module
import UsersPredefinedDataPage from 'pages/predefined-data-module/users/UsersPredefinedDataPage';
import AddUsersPredefinedDataPage from 'pages/predefined-data-module/users/AddUsersPredefinedDataPage';
import EditUsersPredefinedDataPage from 'pages/predefined-data-module/users/EditUsersPredefinedDataPage';

import GlobalPredefinedDataPage from 'pages/predefined-data-module/global/GlobalPredefinedDataPage';
import AddGlobalPredefinedDataPage from 'pages/predefined-data-module/global/AddGlobalPredefinedDataPage';
import EditGlobalPredefinedDataPage from 'pages/predefined-data-module/global/EditGlobalPredefinedDataPage';

import AddMeasuringDevicePage from 'pages/predefined-data-module/measuring-device/AddMeasuringDevicePage';
import EditMeasuringDevicePage from 'pages/predefined-data-module/measuring-device/EditMeasuringDevicePage';
import MeasuringDevicesPage from 'pages/predefined-data-module/measuring-device/MeasuringDevicesPage';

// Devices module
import DevicesPage from 'pages/devices-module/device/DevicesPage';
import AddDevicePage from 'pages/devices-module/device/AddDevicePage';
import EditDevicePage from 'pages/devices-module/device/EditDevicePage';
import CopyDevicePage from 'pages/devices-module/device/CopyDevicePage';
import FaultsPage from 'pages/devices-module/faults/FaultsPage';

import DeviceFaultsPage from 'pages/devices-module/device/DeviceFaultsPage';

import DeviceTypesPage from 'pages/devices-module/device-types/DeviceTypesPage';
import AddDeviceSubtypePage from 'pages/devices-module/device-types/device-subtypes/AddDeviceSubtypePage';
import EditDeviceSubtypePage from 'pages/devices-module/device-types/device-subtypes/EditDeviceSubtypePage';
import DeviceSubtypesPage from 'pages/devices-module/device-types/device-subtypes/DeviceSubtypesPage';

import EvidenceFieldSectionsPage from 'pages/devices-module/evidence-field/EvidenceFieldSectionsPage';
import EvidenceFieldSectionFormPage from 'pages/devices-module/evidence-field/EvidenceFieldSectionFormPage';
import EvidenceFieldsPage from 'pages/devices-module/evidence-field/EvidenceFieldsPage';

// Revisions module
import RevisionsPage from 'pages/revisions-module/revisions/RevisionsPage';
import SignaturesPage from 'pages/revisions-module/signatures/SignaturesPage';
import SignaturePage from 'pages/revisions-module/signatures/SignaturePage';
import RevisionPage from 'pages/revisions-module/revisions/RevisionPage';
import AddRevisionPage from 'pages/revisions-module/add-revision/AddRevisionPage';
import CopyRevisionPage from 'pages/revisions-module/copy-revision/CopyRevisionPage';
import EditRevisionPage from 'pages/revisions-module/edit-revision/EditRevisionPage';
import FillOutRevisionPage from 'pages/revisions-module/fill-out-revision/FillOutRevisionPage';
import RevisionPlanAssignmentsPage from 'pages/revisions-module/plan-assignments/RevisionPlanAssignmentsPage';
import SelectTemplatePage from 'pages/revisions-module/select-template-and-visual/SelectTemplatePage';
import RevisionPlansPage from 'pages/revisions-module/revision-plans/RevisionPlansPage';
import TemplateEditorPage from 'pages/revisions-module/template-editor/TemplateEditorPage';

// Route decorators
import RequireAuth from 'routes/decorators/RequireAuth';
import RequirePermission from 'routes/decorators/RequirePermission';
import RequireOrganizationModule from 'routes/decorators/RequireOrganizationModule';

// Feature toggles
import {
  FEATURE_TOGGLE_ADMIN_IMPERSONATE_SECRET_PAGE,
  FEATURE_TOGGLE_BROWSE_REVISION_TEMPLATES,
  FEATURE_TOGGLE_BULK_SIGN_REVISION,
  FEATURE_TOGGLE_CREATE_DEVICE_SUBTYPES,
  FEATURE_TOGGLE_EXPORT_PAGE,
  FEATURE_TOGGLE_HR_MODULE,
  FEATURE_TOGGLE_DEVICE_QR_CODES,
  FEATURE_TOGGLE_PRICE_OFFERS,
  FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR,
  FEATURE_TOGGLE_TEST_PAGE,
} from 'env';

import RevisionTemplatesPage from 'pages/revisions-module/revision-template/RevisionTemplatesPage';
import EditRevisionTemplatePage from 'pages/revisions-module/revision-template/EditRevisionTemplatePage';
import AddRevisionTemplatePage from 'pages/revisions-module/revision-template/AddRevisionTemplatePage';
import CopyRevisionTemplatePage from 'pages/revisions-module/revision-template/CopyRevisionTemplatePage';
import SystemExportPage from 'pages/admin-module/system-export/SystemExportPage';
import AddEvidenceFieldPage from 'pages/devices-module/evidence-field/AddEvidenceFieldPage';
import EditEvidenceFieldPage from 'pages/devices-module/evidence-field/EditEvidenceFieldPage';
import PriceOffersPage from 'pages/price-offers-module/PriceOffersPage';
import AddPriceOfferPage from 'pages/price-offers-module/AddPriceOfferPage';
import ProvidePriceOfferPage from 'pages/price-offers-module/ProvidePriceOfferPage';
import PriceOfferPage from 'pages/price-offers-module/PriceOfferPage';
import HrPeoplePage from 'pages/hr-module/HrPeoplePage';
import HrPersonPage from 'pages/hr-module/HrPersonPage';
import HrTermsPage from 'pages/hr-module/HrTermsPage';
import HrBulkCreateTermsPage from 'pages/hr-module/HrBulkCreateTermsPage';
import HrTermPage from 'pages/hr-module/HrTermPage';
import HrFileCategoriesPage from 'pages/hr-module/HrFileCategoriesPage';
import HrFileCategoryFormPage from 'pages/hr-module/HrFileCategoryFormPage';
import HrTermTypeFormPage from 'pages/hr-module/HrTermTypeFormPage';
import HrTermTypesPage from 'pages/hr-module/HrTermTypesPage';

const priceOfferPermissions = ['assign-price-offers', 'provide-price-offers'];
const fillPermissionByDocumentModule = {
  revisions: 'fill-out-revisions',
  forms: 'fill-out-forms',
};

/**
 * All routes in the app must be registered here.
 */
export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Auth */}
      <Route path={LOGIN_PAGE_PATH.original} element={<LoginPage />} />
      <Route path={RESET_PASSWORD_PAGE_PATH.original} element={<ResetPasswordPage />} />
      <Route path={SET_NEW_PASSWORD_PAGE_PATH.original} element={<SetNewPasswordPage />} />
      <Route path={EXPIRED_RESET_LINK_PAGE_PATH.original} element={<ExpiredResetLinkPage />} />

      <Route element={<RequireAuth />}>
        {/* Dashboard */}
        <Route path={DASHBOARD_PAGE_PATH.original} element={<DashboardPage />} />

        {/* Profile */}
        <Route path={WELCOME_PAGE_PATH.original} element={<WelcomePage />} />
        <Route path={PASSWORD_CHANGE_REQUIRED_PAGE_PATH.original} element={<PasswordChangeRequiredPage />} />
        <Route path={MY_PROFILE_PAGE_PATH.original} element={<MyProfilePage />} />
        <Route element={<RequireOrganizationModule module="revisions" />}>
          <Route path={MY_CERTIFICATES_PAGE_PATH.original} element={<MyCertificatesPage />} />
          <Route path={MY_COMPANY_SETTINGS_PAGE_PATH.original} element={<MyCompanySettingsPage />} />
        </Route>
        <Route path={NOTIFICATION_SETTINGS_PAGE_PATH.original} element={<NotificationSettingsPage />} />
        <Route path={LOGOUT_PAGE_PATH.original} element={<LogoutPage />} />

        {/* Export */}
        {FEATURE_TOGGLE_EXPORT_PAGE && <Route path={EXPORT_PAGE_PATH.original} element={<SystemExportPage />} />}

        {/* Device subtypes */}
        {FEATURE_TOGGLE_CREATE_DEVICE_SUBTYPES && (
          <Route element={<RequirePermission permission="define-device-subtypes" />}>
            <Route path={DEVICE_TYPES_PAGE_PATH.original} element={<DeviceTypesPage />} />
            <Route path={ADD_DEVICE_SUBTYPE_PAGE_PATH.original} element={<AddDeviceSubtypePage />} />
            <Route path={EDIT_DEVICE_SUBTYPE_PAGE_PATH.original} element={<EditDeviceSubtypePage />} />
            <Route path={DEVICE_SUBTYPES_PAGE_PATH.original} element={<DeviceSubtypesPage />} />
          </Route>
        )}

        {/* Evidence fields */}
        <Route path={EVIDENCE_FIELD_SECTIONS_PAGE_PATH.original} element={<EvidenceFieldSectionsPage />} />
        <Route path={ADD_EVIDENCE_FIELD_SECTION_PAGE_PATH.original} element={<EvidenceFieldSectionFormPage />} />
        <Route path={EDIT_EVIDENCE_FIELD_SECTION_PAGE_PATH.original} element={<EvidenceFieldSectionFormPage edit />} />
        <Route path={EVIDENCE_FIELDS_PAGE_PATH.original} element={<EvidenceFieldsPage />} />
        <Route path={ADD_EVIDENCE_FIELD_PAGE_PATH.original} element={<AddEvidenceFieldPage />} />
        <Route path={EDIT_EVIDENCE_FIELD_PAGE_PATH.original} element={<EditEvidenceFieldPage />} />

        {/* Human resources */}
        {FEATURE_TOGGLE_HR_MODULE && (
          <Route element={<RequireOrganizationModule module="hr" />}>
            <Route element={<RequirePermission permission="browse-hr" />}>
              <Route path={HR_PEOPLE_PAGE_PATH.original} element={<HrPeoplePage />} />
              <Route path={HR_TERMS_PAGE_PATH.original} element={<HrTermsPage />} />
              <Route path={HR_TERM_PAGE_PATH.original} element={<HrTermPage />} />
              <Route path={HR_EDIT_PERSON_PAGE_PATH.original} element={<HrPersonPage edit />} />
              <Route element={<RequirePermission permission="manage-hr" />}>
                <Route path={HR_CREATE_PERSON_PAGE_PATH.original} element={<HrPersonPage create />} />
                <Route path={HR_COPY_PERSON_PAGE_PATH.original} element={<HrPersonPage copy />} />
                <Route path={HR_BULK_CREATE_TERMS_PAGE_PATH.original} element={<HrBulkCreateTermsPage />} />
              </Route>
            </Route>
            <Route element={<RequirePermission permission="manage-hr" />}>
              <Route path={HR_CREATE_PERSON_TERM_PAGE_PATH.original} element={<HrPersonPage termMode="create" />} />
              <Route element={<RequirePermission permission="access-hr-files" />}>
                <Route path={HR_CREATE_PERSON_FILE_PAGE_PATH.original} element={<HrPersonPage fileMode="create" />} />
                <Route path={HR_EDIT_PERSON_FILE_PAGE_PATH.original} element={<HrPersonPage fileMode="edit" />} />
              </Route>
            </Route>
            <Route path={HR_TERM_TYPES_PAGE_PATH.original} element={<HrTermTypesPage />} />
            <Route path={HR_CREATE_TERM_TYPE_PAGE_PATH.original} element={<HrTermTypeFormPage />} />
            <Route path={HR_EDIT_TERM_TYPE_PAGE_PATH.original} element={<HrTermTypeFormPage />} />
            <Route path={HR_FILE_CATEGORIES_PAGE_PATH.original} element={<HrFileCategoriesPage />} />
            <Route path={HR_CREATE_FILE_CATEGORY_PAGE_PATH.original} element={<HrFileCategoryFormPage />} />
            <Route path={HR_EDIT_FILE_CATEGORY_PAGE_PATH.original} element={<HrFileCategoryFormPage />} />
          </Route>
        )}

        {/* Revision templates */}
        {FEATURE_TOGGLE_BROWSE_REVISION_TEMPLATES && (
          <Route element={<RequireOrganizationModule module="revisionTemplates" />}>
            <Route element={<RequirePermission permission="manage-templates" />}>
              <Route path={REVISION_TEMPLATES_PAGE_PATH.original} element={<RevisionTemplatesPage />} />
              <Route path={EDIT_REVISION_TEMPLATE_PAGE_PATH.original} element={<EditRevisionTemplatePage />} />
              {FEATURE_TOGGLE_REVISION_TEMPLATE_EDITOR && (
                <>
                  <Route path={ADD_REVISION_TEMPLATE_PAGE_PATH.original} element={<AddRevisionTemplatePage />} />
                  <Route path={COPY_REVISION_TEMPLATE_PAGE_PATH.original} element={<CopyRevisionTemplatePage />} />
                  <Route path={TEMPLATE_EDITOR_PAGE_PATH.original} element={<TemplateEditorPage />} />
                </>
              )}
            </Route>
          </Route>
        )}

        {/* Users */}
        <Route element={<RequirePermission permission="manage-users" />}>
          <Route path={USERS_PAGE_PATH.original} element={<UsersPage />} />
          <Route path={ADD_USER_PAGE_PATH.original} element={<AddUserPage />} />
          <Route path={EDIT_USER_PAGE_PATH.original} element={<EditUserPage />} />
        </Route>

        {/* Organizations */}
        <Route element={<RequirePermission permission="manage-organizations" scope="global" />}>
          <Route path={ORGANIZATIONS_PAGE_PATH.original} element={<OrganizationsPage />} />
          <Route path={ADD_ORGANIZATION_PAGE_PATH.original} element={<AddOrganizationPage />} />
          <Route path={EDIT_ORGANIZATION_PAGE_PATH.original} element={<EditOrganizationPage />} />
        </Route>

        {/* Departments */}
        <Route element={<RequirePermission permission="manage-departments" />}>
          <Route path={DEPARTMENTS_PAGE_PATH.original} element={<DepartmentsPage />} />
          <Route path={ADD_DEPARTMENT_PAGE_PATH.original} element={<AddDepartmentPage />} />
          <Route path={EDIT_DEPARTMENT_PAGE_PATH.original} element={<EditDepartmentPage />} />
        </Route>

        {/* Hierarchies */}
        <Route element={<RequirePermission permission="manage-hierarchies" scope="global" />}>
          <Route path={HIERARCHIES_PAGE_PATH.original} element={<HierarchiesPage />} />
          <Route path={ADD_HIERARCHY_PAGE_PATH.original} element={<AddHierarchyPage />} />
          <Route path={EDIT_HIERARCHY_PAGE_PATH.original} element={<EditHierarchyPage />} />
        </Route>

        {/* Remote Sources */}
        <Route path={REMOTE_SOURCES_PAGE_PATH.original} element={<RemoteSourcesPage />} />
        <Route path={ADD_REMOTE_SOURCE_PAGE_PATH.original} element={<AddRemoteSourcePage />} />
        <Route path={EDIT_REMOTE_SOURCE_PAGE_PATH.original} element={<EditRemoteSourcePage />} />
        <Route path={COPY_REMOTE_SOURCE_PAGE_PATH.original} element={<CopyRemoteSourcePage />} />
        <Route path={CONFIG_REMOTE_SOURCE_PAGE_PATH.original} element={<ConfigRemoteSourcePage />} />

        {/* User pre-defined data */}
        <Route
          element={
            <RequireOrganizationModule
              module={['revisions', 'forms']}
              permissionByModule={fillPermissionByDocumentModule}
            />
          }
        >
          <Route path={USERS_PREDEFINED_DATA_PAGE_PATH.original} element={<UsersPredefinedDataPage />} />
          <Route path={ADD_USERS_PREDEFINED_DATA_PAGE_PATH.original} element={<AddUsersPredefinedDataPage />} />
          <Route path={EDIT_USERS_PREDEFINED_DATA_PAGE_PATH.original} element={<EditUsersPredefinedDataPage />} />
        </Route>

        {/* Global pre-defined data */}
        <Route element={<RequirePermission permission="manage-global-predefined-data" scope="global" />}>
          <Route path={GLOBAL_PREDEFINED_DATA_PAGE_PATH.original} element={<GlobalPredefinedDataPage />} />
          <Route path={ADD_GLOBAL_PREDEFINED_DATA_PAGE_PATH.original} element={<AddGlobalPredefinedDataPage />} />
          <Route path={EDIT_GLOBAL_PREDEFINED_DATA_PAGE_PATH.original} element={<EditGlobalPredefinedDataPage />} />
        </Route>

        {/* Measuring devices */}
        <Route
          element={
            <RequireOrganizationModule
              module={['revisions', 'forms']}
              permissionByModule={fillPermissionByDocumentModule}
            />
          }
        >
          <Route path={MEASURING_DEVICES_PAGE_PATH.original} element={<MeasuringDevicesPage />} />
          <Route path={ADD_MEASURING_DEVICE_PAGE_PATH.original} element={<AddMeasuringDevicePage />} />
          <Route path={EDIT_MEASURING_DEVICE_PAGE_PATH.original} element={<EditMeasuringDevicePage />} />
        </Route>

        {/* Devices */}
        <Route element={<RequirePermission permission="browse-devices" />}>
          <Route path={DEVICES_PAGE_PATH.original} element={<DevicesPage />} />
          <Route path={FAULTS_PAGE_PATH.original} element={<FaultsPage />} />
          <Route element={<RequirePermission permission="manage-devices" />}>
            <Route path={ADD_DEVICE_PAGE_PATH.original} element={<AddDevicePage />} />
            <Route path={COPY_DEVICE_PAGE_PATH.original} element={<CopyDevicePage />} />
          </Route>
          <Route path={EDIT_DEVICE_PAGE_PATH.original} element={<EditDevicePage />} />
          <Route path={DEVICE_FAULTS_PAGE_PATH.original} element={<DeviceFaultsPage />} />
          <Route element={<RequireOrganizationModule module="revisions" />}>
            <Route path={DEVICE_REVISION_PLANS_PAGE_PATH.original} element={<RevisionPlansPage />} />
          </Route>
        </Route>

        {/* Revisions */}
        <Route element={<RequireOrganizationModule module="revisions" />}>
          <Route element={<RequirePermission permission="*-revisions" />}>
            <Route path={REVISIONS_PAGE_PATH.original} element={<RevisionsPage kind="revision" />} />
          </Route>
          <Route path={REVISION_PAGE_PATH.original} element={<RevisionPage />} />
          <Route element={<RequirePermission permission="assign-revisions" />}>
            <Route path={ADD_REVISION_PAGE_PATH.original} element={<AddRevisionPage kind="revision" />} />
            <Route path={COPY_REVISION_PAGE_PATH.original} element={<CopyRevisionPage />} />
            <Route path={EDIT_REVISION_PAGE_PATH.original} element={<EditRevisionPage />} />
          </Route>
          <Route element={<RequirePermission permission="fill-out-revisions" />}>
            <Route path={REVISION_PLAN_ASSIGNMENTS_PAGE_PATH.original} element={<RevisionPlanAssignmentsPage />} />
            <Route path={SELECT_REVISION_TEMPLATE_AND_VISUAL_PAGE_PATH.original} element={<SelectTemplatePage />} />
            <Route path={FILL_OUT_REVISION_PAGE_PATH.original} element={<FillOutRevisionPage />} />
          </Route>
        </Route>

        {/* Forms */}
        <Route element={<RequireOrganizationModule module="forms" />}>
          <Route element={<RequirePermission permission="*-forms" />}>
            <Route path={FORMS_PAGE_PATH.original} element={<RevisionsPage kind="form" />} />
          </Route>
          <Route path={FORM_PAGE_PATH.original} element={<RevisionPage />} />
          <Route element={<RequirePermission permission="assign-forms" />}>
            <Route path={ADD_FORM_PAGE_PATH.original} element={<AddRevisionPage kind="form" />} />
            <Route path={COPY_FORM_PAGE_PATH.original} element={<CopyRevisionPage />} />
            <Route path={EDIT_FORM_PAGE_PATH.original} element={<EditRevisionPage />} />
          </Route>
          <Route element={<RequirePermission permission="fill-out-forms" />}>
            <Route path={SELECT_FORM_TEMPLATE_AND_VISUAL_PAGE_PATH.original} element={<SelectTemplatePage />} />
            <Route path={FILL_OUT_FORM_PAGE_PATH.original} element={<FillOutRevisionPage />} />
          </Route>
        </Route>

        {/* Price offers */}
        {FEATURE_TOGGLE_PRICE_OFFERS && (
          <Route element={<RequireOrganizationModule module="priceOffers" />}>
            <Route element={<RequirePermission oneOfPermissions={priceOfferPermissions} />}>
              <Route path={PRICE_OFFERS_PAGE_PATH.original} element={<PriceOffersPage />} />
              <Route path={PRICE_OFFER_PAGE_PATH.original} element={<PriceOfferPage />} />
            </Route>
            <Route element={<RequirePermission permission="assign-price-offers" />}>
              <Route path={ADD_PRICE_OFFER_PAGE_PATH.original} element={<AddPriceOfferPage />} />
            </Route>
            <Route element={<RequirePermission permission="provide-price-offers" />}>
              <Route path={PROVIDE_PRICE_OFFER_PAGE_PATH.original} element={<ProvidePriceOfferPage />} />
            </Route>
          </Route>
        )}

        {/* Signature */}
        {FEATURE_TOGGLE_BULK_SIGN_REVISION && (
          <Route
            element={
              <RequireOrganizationModule
                module={['revisions', 'forms']}
                permissionByModule={fillPermissionByDocumentModule}
              />
            }
          >
            <Route path={SIGNATURES_PAGE_PATH.original} element={<SignaturesPage />} />
            <Route path={SIGNATURE_PAGE_PATH.original} element={<SignaturePage />} />
          </Route>
        )}

        {/* Test */}
        {FEATURE_TOGGLE_TEST_PAGE && <Route path={TEST_PAGE_PATH.original} element={<TestPage />} />}

        {/* Secret admin impersonation */}
        {FEATURE_TOGGLE_ADMIN_IMPERSONATE_SECRET_PAGE && (
          <Route path={ADMIN_IMPERSONATE_USER_PAGE_PATH.original} element={<ImpersonateUserPage />} />
        )}

        {/* Redirect */}
        <Route path={REDIRECT_PAGE_PATH.original} element={<RedirectPage />} />

        {FEATURE_TOGGLE_DEVICE_QR_CODES && (
          <Route path={DEVICE_QR_PAGE_PATH.original} element={<DeviceQrRedirectPage />} />
        )}

        <Route path={NOT_FOUND_PAGE_PATH.original} element={<NotFoundPage />} />

        {/* External Redirect (BrainIT) */}
        <Route path={EXTERNAL_REDIRECT_PAGE_PATH.original} element={<ExternalRedirectPage />} />

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </>
  )
);
